import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, SegmentedControl, Paper, Text, ActionIcon } from '@mantine/core';
import { IconChevronRight, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { safeValue, regexNumberOnly } from "../../utils/globalFunctions";

import InputComponent from "../../components/general/InputComponent";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import ModalResponse from "../../components/general/ModalResponse";

import StockCategorySelectorDrawer from "../../components/utilities/StockCategorySelectorDrawer";

const StockCategorySubEdit = ({ stateShow, fnShow, stateData, fnSuccessEdit }) => {

    const mountedRef = React.useRef(true);
    // const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'stockCategorySubEdit-1',
        successSubmitData: 'stockCategorySubEdit-2',
    })

    const constStockCategorySubName = {
        id: 'editStockCategorySubName',
        label: 'Sub Kategori',
        withAsterisk: true,
        placeholder: 'Contoh: Samsung DDR 4',
        value: '',
        description: '',
        error: ''
    }

    const constStockCategory = {
        id: 'editStockCategory',
        label: 'Kategori',
        withAsterisk: true,
        value: {
            show: false,
            id: '',
            name: '',
            isActive: '',
        },
        description: '',
        error: ''
    }

    const constStockCategorySubMinStock = {
        id: 'editStockCategorySubMinStock',
        label: 'Stok Minimal',
        withAsterisk: true,
        placeholder: 'Stok Minimal',
        value: '',
        description: '',
        error: ''
    }

    const constStockCategorySubIsActive = {
        id: 'editStockCategorySubIsActive',
        label: 'Status',
        withAsterisk: true,
        placeholder: 'Status',
        value: '1',
        description: '',
        error: ''
    }

    const [data, setData] = React.useState({
        stockCategorySubName: constStockCategorySubName,
        stockCategory: constStockCategory,
        stockCategorySubMinStock: constStockCategorySubMinStock,
        stockCategorySubIsActive: constStockCategorySubIsActive,

        submitLoading: false,
        resetData: new Date(),

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        setData(d => ({
            ...d,
            stockCategorySubName: {
                ...d.stockCategorySubName,
                value: safeValue(stateData.stock_category_sub_name, ''),
                error: '',
            },
            stockCategory: {
                ...d.stockCategory,
                value: {
                    ...d.stockCategory.value,
                    id: stateData.stock_category_id,
                    name: stateData.stock_category_name,
                    isActive: stateData.stock_category_is_active,
                    show: false,
                },
                error: '',
            },
            stockCategorySubMinStock: {
                ...d.stockCategorySubMinStock,
                value: safeValue(stateData.stock_category_sub_stock_min, ''),
                error: '',
            },
            stockCategorySubIsActive: {
                ...d.stockCategorySubIsActive,
                value: safeValue(stateData.stock_category_sub_is_active, '1'),
                error: '',
            },
        }))
    }, [stateData, data.resetData])

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const resetData = () => {
        setData(d => ({ ...d, resetData: new Date() }))
    }

    const editData = () => {
        setData(d => ({
            ...d,
            stockCategory: { ...d.stockCategory, error: '' },
            stockCategorySubName: { ...d.stockCategorySubName, error: '' },
            stockCategorySubMinStock: { ...d.stockCategorySubMinStock, error: '' },
        }));

        if (validator.isEmpty(data.stockCategory.value.id, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockCategory: { ...d.stockCategory, error: 'Kategori stok wajib diisi!', } }));
        } else if (validator.isEmpty(data.stockCategorySubName.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockCategorySubName: { ...d.stockCategorySubName, error: 'Sub kategori stok wajib diisi!', } }));
        } else if (validator.isEmpty(data.stockCategorySubMinStock.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, stockCategorySubMinStock: { ...d.stockCategorySubMinStock, error: 'Stok minimal wajib diisi!', } }));
        } else {
            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('stock_category_sub_id', stateData.stock_category_sub_id);
            formDT.append('stock_category', data.stockCategory.value.id);
            formDT.append('stock_category_name', data.stockCategory.value.name);

            formDT.append('stock_category_sub_name', data.stockCategorySubName.value);
            formDT.append('stock_category_sub_stock_min', data.stockCategorySubMinStock.value);
            formDT.append('stock_category_sub_is_active', data.stockCategorySubIsActive.value);

            axios({
                method: 'post',
                url: BE_API_ONE + '/edit_stock_category_sub',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    fnSuccessEdit();

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Edit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-name') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Sub kategori ${response.data.suspect} sudah pernah didaftarkan pada kategori ${response.data.suspect_2}`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Edit Sub Kategori</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockCategory.label}
                            stateWithAsterisk={data.stockCategory.withAsterisk}
                            stateError={data.stockCategory.error}
                            stateDescription={data.stockCategory.description}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        stockCategory: {
                                            ...d.stockCategory,
                                            value: {
                                                ...d.stockCategory.value,
                                                show: true
                                            }
                                        }
                                    }));
                                }}
                            >
                                {data.stockCategory.value.id === '' &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Pilih Kategori</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.stockCategory.value.id &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.stockCategory.value.name}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.stockCategory.value.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <IconChevronRight size="1.25rem" />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.stockCategorySubName.id}
                            stateWithAsterisk={data.stockCategorySubName.withAsterisk}
                            stateLabel={data.stockCategorySubName.label}
                            stateDescription={data.stockCategorySubName.description}
                            statePlaceHolder={data.stockCategorySubName.placeholder}
                            stateValue={data.stockCategorySubName.value}
                            stateError={data.stockCategorySubName.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                stockCategorySubName: {
                                    ...d.stockCategorySubName,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.stockCategorySubMinStock.id}
                            stateWithAsterisk={data.stockCategorySubMinStock.withAsterisk}
                            stateLabel={data.stockCategorySubMinStock.label}
                            stateDescription={data.stockCategorySubMinStock.description}
                            statePlaceHolder={data.stockCategorySubMinStock.placeholder}
                            stateValue={data.stockCategorySubMinStock.value}
                            stateError={data.stockCategorySubMinStock.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                stockCategorySubMinStock: {
                                    ...d.stockCategorySubMinStock,
                                    value: regexNumberOnly(e.target.value)
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel={data.stockCategorySubIsActive.label}
                            stateWithAsterisk={data.stockCategorySubIsActive.withAsterisk}
                            stateError={data.stockCategorySubIsActive.error}
                            stateDescription={data.stockCategorySubIsActive.description}
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.stockCategorySubIsActive.value}
                                onChange={(val) => setData(d => ({
                                    ...d,
                                    stockCategorySubIsActive: {
                                        ...d.stockCategorySubIsActive,
                                        value: val
                                    }
                                }))}
                                data={[
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            loading={data.submitLoading}
                            onClick={editData}
                        >
                            Submit
                        </Button>
                    </Group>

                </Box>
            </Drawer>

            <StockCategorySelectorDrawer
                stateShow={data.stockCategory.value.show}

                fnShow={() => setData(d => ({
                    ...d,
                    stockCategory: {
                        ...d.stockCategory,
                        value: {
                            ...d.stockCategory.value,
                            show: false
                        }
                    }
                }))}

                fnOnSelect={(id, name, isActive) => setData(d => ({
                    ...d,
                    stockCategory: {
                        ...d.stockCategory,
                        value: {
                            ...d.stockCategory.value,
                            id: id,
                            name: name,
                            isActive: isActive,
                            show: false
                        }
                    }
                }))}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default StockCategorySubEdit;